import * as wjcXlsx from '@mescius/wijmo.xlsx'
import moment from 'moment'

function getItems (table) {
  // 出力の各行は、契約に関する情報（各ブロック先頭の行に記載）＋アイテムに関する情報（アイテム行の各列に対応）
  const contractFields = ['会社名', '契約方式', 'キャラクター名', '契約開始日', '契約終了日']
  const itemFields = []
  table.querySelectorAll('thead')[0].querySelectorAll('th').forEach((th) => {
    itemFields.push(th.innerText)
  })

  let contractValues = Array.from({ length: contractFields.length }, () => '')
  const items = [contractFields.concat(itemFields)]
  table.querySelectorAll('tbody')[0].querySelectorAll('tr').forEach((tr) => {
    if (tr.classList.contains('row-contract')) {
      // 各契約ブロックの先頭にある契約に関する情報を分解してcontractValuesに格納する
      const cell = tr.querySelector('td.cell-contract')
      const textMatch = cell.innerText.match(/^(.+) \/ (アイテム個別|グロス|クロスリクープ) \/ (.+) \/ 契約期間：(.+)～(.+)$/)
      contractValues = Array.from({ length: contractFields.length }, (v, k) => textMatch[k + 1])
    } else {
      // 各アイテムの情報をitemValuesに格納する
      const itemValues = []
      tr.querySelectorAll('td').forEach((td, i) => {
        if (itemFields[i] === '税抜小売価格') {
          const price = Number.parseInt(td.innerText.replace('￥', '').replace(',', ''))
          itemValues.push(price)
        } else {
          itemValues.push(td.innerText)
        }
      })
      items.push(contractValues.concat(itemValues))
    }
  })

  return items
}

function getWorkbook (items) {
  const workbook = new wjcXlsx.Workbook()
  const sheet = new wjcXlsx.WorkSheet()
  workbook.sheets.push(sheet)

  items.forEach((row, i) => {
    sheet.rows[i] = new wjcXlsx.WorkbookRow()
    row.forEach((v, j) => {
      sheet.rows[i].cells[j] = new wjcXlsx.WorkbookCell()
      sheet.rows[i].cells[j].value = v
    })
  })

  // 列幅を設定
  const rowsWidth = [
    140,
    100,
    160,
    90,
    90,
    40,
    160,
    70,
    50,
    70,
    70,
    40,
    70,
    70
  ]
  rowsWidth.forEach((width, i) => {
    sheet.columns[i] = new wjcXlsx.WorkbookColumn()
    sheet.columns[i].width = width
  })

  return workbook
}

document.querySelectorAll('.export-items-table').forEach((el) => {
  const exportTargetId = 'items-table'
  const table = document.getElementById(exportTargetId)
  if (!table) {
    console.error(`idが${exportTargetId}であるtable要素が存在しません。`)
    return
  }
  el.addEventListener('click', (e) => {
    const items = getItems(table)
    const workbook = getWorkbook(items)

    const nowStr = moment().format('YYYY-MM-DD-HHmmss')
    workbook.saveAsync(`アイテム一覧_${nowStr}.xlsx`)
  })
})
